import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-bootstrap';

class SelectFormatter extends PureComponent {
	render() {
		const { onClickCheckbox, checked } = this.props;

		return (
			<Checkbox
				checked={checked}
				onChange={onClickCheckbox}
				data-prevent-navigation
			/>
		);
	}
}

SelectFormatter.propTypes = {
	checked         : PropTypes.bool,
	onClickCheckbox : PropTypes.func,
};

SelectFormatter.defaultProps = {
	checked         : false,
	onClickCheckbox : () => undefined,
};

export default SelectFormatter;
